import React from 'react';
import { Link } from 'react-router-dom';
import documentIntroIcon from '@/assets/images/documentIntroIcon.jpg';
import { getPropertyAddress } from '@/utils/properties';
import { Skeleton } from '@/components/ui/skeleton';
import DocumentListItem from '@componentsV2/DocumentListItem';
import { Button } from '@/components/ui/button';

const PropertyDocumentsEntry = ({ propertyDocuments, property, fetching }) => {
  const isLoading = () => fetching || !property;
  return (
    <div className="flex flex-col gap-1">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h3 className="text-[18px] md:text-xl font-medium mb-1 md:mb-2">
            Dokumenter
          </h3>
          <p className="block md:hidden text-sm font-normal text-foreground opacity-65">
            Siste dokumenter for {getPropertyAddress(property)}
          </p>
        </div>
        <Link
          to={`/dashboard/${property?.boligmappaNumber}/documents`}
          className="hidden md:block text-[15px] opacity-[50%] font-medium"
        >
          Gå til dokumenter ›
        </Link>
      </div>
      <div className="flex flex-col items-center w-full justify-center text-center">
        {isLoading() && (
          <div className="flex flex-col space-y-2 w-full">
            <Skeleton className="bg-secondary h-14 md:h-20 w-full" />
            <Skeleton className="bg-secondary h-14 md:h-20 w-full" />
            <Skeleton className="bg-secondary h-14 md:h-20 w-full" />
            <Skeleton className="bg-secondary h-14 md:h-20 w-full" />
          </div>
        )}
        {!isLoading() &&
          (propertyDocuments?.length > 0 ? (
            <div className="flex flex-col w-full">
              {propertyDocuments.slice(0, 4).map((doc) => (
                <DocumentListItem
                  classes="md:border-b border-color-[#0000007] py-3"
                  key={doc.id}
                  document={doc}
                  docPath={`/dashboard/${property?.boligmappaNumber}/documents`}
                />
              ))}
            </div>
          ) : (
            <>
              <img
                src={documentIntroIcon}
                alt="Document Intro"
                className="mb-6 w-[79px]"
              />
              <span className="text-base md:text-[22px]">
                Denne boligen har ingen dokumenter. Husk å{' '}
                <Link
                  className=" underline"
                  to={`/dashboard/${property.boligmappaNumber}/create-mdr`}
                >
                  be håndverker
                </Link>{' '}
                om å laste dem opp i Boligmappa, eller{' '}
                <Link
                  className=" underline"
                  to={`/dashboard/${property.boligmappaNumber}/documents`}
                >
                  last opp egne.
                </Link>
              </span>
            </>
          ))}
      </div>
      <Button className="md:hidden border-red-400" asChild variant="outline">
        <Link to={`/dashboard/${property?.boligmappaNumber}/documents`}>
          Alle dokumenter
        </Link>
      </Button>
    </div>
  );
};

export default PropertyDocumentsEntry;
